import { render } from "./MediaAddForm.vue?vue&type=template&id=a4e58ef0"
import script from "./MediaAddForm.vue?vue&type=script&lang=js"
export * from "./MediaAddForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ckyang/dev/olabbio/sites/olab-github/gf-olab-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__